<template>
<div class="row align-items-center justify-content-between flex-nowrap overflow-visible m-0 p-0 g-0">
	<div class="col-auto ms-2">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm m-0"
			@click="showSettings = true"
			:disabled="isLoading"
		>
			<button-icon icon="settings" fill="currentColor"/>
		</button>
	</div>

	<div class="col-auto ms-2">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm m-0"
			@click="updateZoomedArea()"
			:disabled="isLoading"
		>
			<button-icon icon="update" fill="currentColor"/>
		</button>
	</div>

	<div class="col-auto ms-4">
		<!-- Graph period choose -->
		<div class="row m-0 my-2 p-0 justify-content-start align-items-center">
			<!-- Previous button -->
			<div class="col-auto m-0 g-0 p-0 me-2 ">
				<button
					type="button"
					class="btn btn-outline-secondary btn-sm m-0"
					@click="() => onDecrementPeriod()"
					:disabled="isLoading"
				>
					<button-icon icon="triangle-left" fill="currentColor"/>
				</button>
			</div>
			<!-- Period choose dropdown -->
			<div class="col-auto m-0 g-0 p-0 me-2">
				<div ref="periodDropdown" class="">
					<button
						class="btn btn-secondary btn-sm dropdown-toggle"
						type="button"
						data-bs-toggle="dropdown"
						data-bs-auto-close="true"
						aria-expanded="false"
						style="width: 10rem;"
						
					>
						{{ capitalizeFirstLetter(periodDropdownTitle) }}
					</button>
					<ul class="dropdown-menu p-0 py-1">
						<li
							v-for="(el, index) in $options.periods"
							:key="index"
							class=""
						>
							<button
								class="dropdown-item"
								type="button"
								:disabled="isLoading"
								@click="() => { onPeriodChange(index) }"
							>
								{{ capitalizeFirstLetter(el.title) }}
							</button>
						</li>
					</ul>
				</div>
			</div>
			<!-- Next button -->
			<div class="col-auto m-0 g-0 p-0 me-2 ">
				<button
					type="button"
					class="btn btn-outline-secondary btn-sm"
					@click="() => onIncrementPeriod()"
					:disabled="!isIncrementPeriodPossible || isLoading"
				>
					<button-icon icon="triangle-right" fill="currentColor" />
				</button>
			</div>

			<div class="col-auto m-0 g-0 p-0 me-2 ">
				<label class="mx-2" for="from-date"></label>
				<input
					type="date"
					name="from-date"
					ref="fromDate"
					:max="dateLocalString(new Date())"
					@change="onDateChange"
					@keyup.enter="console.log('submit period')"
					:disabled="isLoading"
					@keydown.prevent
					@paste.prevent
					@input.prevent
					style="caret-color: transparent;"
				/>
			</div>
				
			<div class="col-auto m-0 g-0 p-0 ms-2 me-2">
				<div
					class="spinner-border text-secondary m-0 p-0"
					:class="{'d-none': !isLoading,}"
					role="status"
					style="width: 1.6rem; height: 1.6rem;"
				>
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
		</div>
	</div>

	<div class="col-auto ms-auto me-auto"></div>

	<div class="col-auto pe-5">
		<div ref="metricsDropdown" class="dropdown-center dropstart">
			<button
				class="btn btn-secondary btn-sm dropdown-toggle scrollable-dropdown-button"
				type="button"
				data-bs-toggle="dropdown"
				data-bs-auto-close="outside"
				aria-expanded="false"
			>
				Метрики
			</button>
			<ul class="dropdown-menu scrollable-dropdown px-2">
				<div class="d-flex justify-content-between">
					<div class="fw-bold ps-3">
						<button-icon icon="arrow-down-left" />&nbsp;Діаграма</div>
					<div>&nbsp;</div>
					<div class="fw-bold pe-3">
						Таблиця&nbsp;<button-icon icon="arrow-down-right" />
					</div>
				</div>
				<li
					v-for="(el, index) in chartLineItems"
					:key="'lines' + index"
					class="form-check-label dropdown-item d-flex p-1"
				>
					<input
						v-if="el.showInLines !== undefined"
						class="form-check-input"
						type="checkbox"
						value=""
						:id="'lines' + index"
						v-model="el.showInLines"
					>
					<label class="flex-grow-1" :for="'lines' + index">
						<span class="ps-2" :style="{'color': el.lineColor ?? '#FFFFFF',}">
							&#9210;
						</span>
						<unit-icon :unit-type="el.icon" edge-size="16" />
						{{ el.title }}
					</label>
					<input
						v-if="el.showInTable !== undefined"
						class="form-check-input "
						type="checkbox"
						value=""
						:id="'lines' + index"
						v-model="el.showInTable"
					>
				</li>
				<li><hr class="dropdown-divider p-1"></li>
				<li
					v-for="(el, index) in chartSegmentItems"
					:key="'bars' + index"
					class="form-check-label dropdown-item p-1"
				>
					<input
						class="form-check-input"
						type="checkbox"
						value=""
						:id="'bars' + index"
						v-model="el.showInSegments"
					>
					<label class="ps-2" :for="'bars' + index">
						<unit-icon :unit-type="el.icon" edge-size="16" />
						{{ el.title }}
					</label>
				</li>
			</ul>
		</div>
	</div>

	<!-- <div class="col-auto z-3 ms-auto me-auto"></div> -->

	<div class="col-auto z-3 ms-2 me-2">
		<button
			type="button"
			class="btn btn-outline-secondary btn-sm m-0 rounded-circle"
			@click="showAbout = true"
			style="border: 0px;"
		>
			<button-icon icon="question" fill="currentColor"/>
		</button>
	</div>
</div>

<station-analytic-chart
	class="chart"
	:station-id="stationId"
	:items="chartItemsConfig"
	:reset-metrics-data="resetChartData"
	:fill-undefined-as-previous="fillUndefAsPrev"
	:poi-range-seconds="POI_RANGE_S"
	:periodFrom="chartsPeriodFrom"
	:periodTo="chartsPeriodTo"
	@is-loading="(v) => isLoading = v"
	@is-table="(v) => isTable = v"
	@update-zoomed-area="(v) => updateZoomedArea = v"
	@point-of-interest="(v) => poi = v"
/>

<div
	v-show="isTable"
	class="bottom-table"
>
	<station-analytic-table
		:station-id="stationId"
		:items="tableItems"
		:poi="poi"
		:poi-range-seconds="POI_RANGE_S"
		:is-loading="isLoading"
		:height="Number(tableHeight.slice(0, -2))"
	/>
</div>

<!-- Chart settings pop-up -->
<pop-up-modal
	v-model:show="showSettings"
	size=""
	title="Налаштування"
	confirmButtonTitle="Застосувати"
	@confirm="updateZoomedArea()"
	@reject="showSettings = false"
>
	<template v-slot:body>
		<div class="form-check">
			<input
				class="form-check-input"
				type="checkbox"
				id="fill-undefined-to-prev-value"
				v-model="fillUndefAsPrev"
				@change="resetChartData = true"
			>
			<label class="form-check-label" for="fill-undefined-to-prev-value">
				Відсутні значення  метрик заповнювати попереднім значенням
			</label>
		</div>
	</template>
</pop-up-modal>

<!-- Chart about pop-up -->
<pop-up-modal
	v-model:show="showAbout"
	size="modal-xl"
	title="Як користуватись аналітиками"
	rejectButtonTitle="Закрити"
	@reject="showAbout = false"
>
	<template v-slot:body>
		<station-analytic-section-about />
	</template>
</pop-up-modal>
</template>




<script>
import StationAnalyticChart from '@/components/Charts/StationAnalyticChart.vue'
import StationAnalyticTable from '@/components/StationView/StationAnalyticTable.vue'
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import PopUpModal from '@/components/PopUpModal.vue'
import StationAnalyticSectionAbout from '@/components/StationView/StationAnalyticSectionAbout.vue'
import { Station } from '@/models/station.js'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ElectricMeter } from '@/models/electricMeter.js'
import { ModemUnit } from '@/models/modemUnit.js'
import {
	INFLUXDB,
} from '@/api/influxdb.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import {
	capitalizeFirstLetter,
	subtractHoursFromNowDate,
	dateLocalString,
	dateTimeToString,
} from '@/helpers.js'



const GREEN = '#73bf69'
const RED = '#f2495c'
const GRAY = '#5f6368'
// const BLUE = '#5794f2'



export default {
	// Chart periods list
	periods: [
		{
			title: 'сьогодні',
			range: 1000 * 60 * 60 * 24,
			rangeTitle: 'доба',
			start: new Date(
				new Date().setHours(0, 0, 0, 0)
				// new Date(new Date(2026, 6, 28).setHours(0, 0, 0, 0))
			),
			end: new Date(
				new Date().setHours(23, 59, 59, 999)
				// new Date(new Date(2026, 6, 29).setHours(23, 59, 59, 999))
			),
		},
		{
			title: 'поточний тиждень',
			range: 1000 * 60 * 60 * 24 * 7,
			rangeTitle: 'тиждень',
			start: new Date(
				new Date(
					new Date().setDate(new Date().getDate() - new Date().getDay() + 1)
				).setHours(0, 0, 0, 0)
			),
			end: new Date(
				new Date(
					new Date().setDate(new Date().getDate() - new Date().getDay() + 7)
				).setHours(23, 59, 59, 999)
			),
		},
		{
			title: 'поточний місяць',
			range: 1000 * 60 * 60 * 24 * 31,
			rangeTitle: 'місяць',
			start: new Date(
				new Date(
					new Date().setDate(1)
				).setHours(0, 0, 0, 0)
			),
			end: new Date(
				new Date(
					new Date(
						new Date().setDate(32)
					).setDate(0)
				).setHours(23, 59, 59, 999)
			),
		},
		{
			title: 'поточний рік',
			range: 1000 * 60 * 60 * 24 * 365,
			rangeTitle: 'рік',
			start: new Date(
				new Date(
					new Date().setFullYear(new Date().getFullYear(), 0, 1)
				).setHours(0, 0, 0, 0)
			),
			end: new Date(
				new Date(
					new Date().setFullYear(new Date().getFullYear(), 11, 31)
				).setHours(23, 59, 59, 999)
			),
		},
	],

	inject: ['headerHeight', ],

	components: {
		StationAnalyticChart,
		StationAnalyticTable,
		ButtonIcon,
		UnitIcon,
		PopUpModal,
		StationAnalyticSectionAbout,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const POI_RANGE_S = 60 * 60 * 2

		return {
			capitalizeFirstLetter,
			dateTimeToString,
			dateLocalString,
			subtractHoursFromNowDate,
			Station,
			accountStore,
			stationsStore,
			POI_RANGE_S,
		}
	},

	data() {
		return {
			// Chart settings pop-up
			showSettings: false,
			fillUndefAsPrev: true,	// make chart more smooth

			// About pop-up
			showAbout: false,

			// Chart period
			periodSource: 'dropdown', // 'dropdown', 'date_picker'
			pickedDate: new Date(new Date().setHours(0, 0, 0, 0)),
			selectedPeriodIndex: 0,   // Selected time period (range)
			periodShift: 0, 		  // can chifts only to past (only negative values)

			resetChartData: false,

			isLoading: false,
			updateZoomedArea: () => {}, // udate chart zoomed area data
			chartItemsConfig: [],
			chartBars: {},

			// Point of interest (Date)
			poi: null,
			// Table show flag
			isTable: false,
		}
	},

	watch: {
		// Update chart on timeFrom update
		async chartsPeriodFrom(newValue) {
			this.$refs.fromDate.value = dateLocalString(newValue)
		}
	},

	created() {
		const flagGroupsConf = {
			breaks: {
				title: 'Аварії',
				// icons for value
				icons: {
					1: [
						{
							color: GRAY,
							path: 'M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z',
						},
						{
							color: RED,
							path: 'm422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z',
							size: 24 / 1.5,
						}
					],

					0: [
						{
							color: GRAY,
							path: 'M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z',
						},
						{
							color: GREEN,
							path: 'm422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z',
							size: 24 / 1.5,
						}
					],
				},
			},

			door_events: {
				title: 'Події',
				// icons for value
				icons: {
					1: [
						{
							color: GRAY,
							path: 'M120-120v-80h80v-640h400v40h160v600h80v80H680v-600h-80v600H120Zm160-640v560-560Zm160 320q17 0 28.5-11.5T480-480q0-17-11.5-28.5T440-520q-17 0-28.5 11.5T400-480q0 17 11.5 28.5T440-440ZM280-200h240v-560H280v560Z',
						},
					],
					0: [
						{
							color: GRAY,
							path: 'M120-120v-80h80v-560q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v560h80v80H120Zm560-80v-560H280v560h400ZM560-440q17 0 28.5-11.5T600-480q0-17-11.5-28.5T560-520q-17 0-28.5 11.5T520-480q0 17 11.5 28.5T560-440ZM280-760v560-560Z',
						},
					],
					// Short circuit
					null: [
						{
							color: RED,
							path: 'M120-120v-80h80v-640h400v40h160v600h80v80H680v-600h-80v600H120Zm160-640v560-560Zm160 320q17 0 28.5-11.5T480-480q0-17-11.5-28.5T440-520q-17 0-28.5 11.5T400-480q0 17 11.5 28.5T440-440ZM280-200h240v-560H280v560Z',
						},
					],
				},
			},

			adjustments: {
				title: 'Налаштування',
				// icons for value
				icons: {
					custom: [
						{
							color: GRAY,
							path: 'M 480 -480 Z M 370 -80 L 354 -208 C 345.333 -211.333 337.167 -215.333 329.5 -220 C 321.833 -224.667 314.333 -229.667 307 -235 L 188 -185 L 78 -375 L 181 -453 C 180.333 -457.667 180 -462.167 180 -466.5 L 180 -493.5 C 180 -497.833 180.333 -502.333 181 -507 L 78 -585 L 188 -775 L 307 -725 C 314.333 -730.333 322 -735.333 330 -740 C 338 -744.667 346 -748.667 354 -752 L 370 -880 L 590 -880 L 606 -752 C 614.667 -748.667 622.833 -744.667 630.5 -740 C 638.167 -735.333 645.667 -730.333 653 -725 L 772 -775 L 882 -585 L 808 -529 C 793.333 -536.333 778.333 -542.5 763 -547.5 C 747.667 -552.5 731.333 -556 714 -558 L 777 -606 L 738 -674 L 639 -632 C 624.333 -647.333 608.167 -660.167 590.5 -670.5 C 572.833 -680.833 553.667 -688.667 533 -694 L 520 -800 L 441 -800 L 427 -694 C 406.333 -688.667 387.167 -680.833 369.5 -670.5 C 351.833 -660.167 335.667 -647.667 321 -633 L 222 -674 L 183 -606 L 269 -542 C 265.667 -532 263.333 -522 262 -512 C 260.667 -502 260 -491.333 260 -480 C 260 -469.333 260.667 -459 262 -449 C 263.333 -439 265.667 -429 269 -419 L 183 -354 L 222 -286 L 321 -328 C 332.333 -316.667 344.5 -306.5 357.5 -297.5 C 370.5 -288.5 384.667 -281 400 -275 C 400.667 -237 408.5 -201.333 423.5 -168 C 438.5 -134.667 458.667 -105.333 484 -80 L 370 -80 Z M 411 -359 C 415 -372.333 419.833 -385.167 425.5 -397.5 C 431.167 -409.833 437.667 -421.667 445 -433 C 437.667 -438.333 432 -445.167 428 -453.5 C 424 -461.833 422 -470.667 422 -480 C 422 -496.667 427.833 -510.833 439.5 -522.5 C 451.167 -534.167 465.333 -540 482 -540 C 491.333 -540 500.333 -537.833 509 -533.5 C 517.667 -529.167 524.667 -523.333 530 -516 C 541.333 -523.333 553 -529.833 565 -535.5 C 577 -541.167 589.667 -545.667 603 -549 C 591 -570.333 574.333 -587.5 553 -600.5 C 531.667 -613.5 508 -620 482 -620 C 442.667 -620 409.5 -606.333 382.5 -579 C 355.5 -551.667 342 -518.667 342 -480 C 342 -454.667 348.167 -431.167 360.5 -409.5 C 372.833 -387.833 389.667 -371 411 -359 Z',
						},
						{
							color: GRAY,
							path: 'm422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z',
							size: 24 / 1.7,
							shiftX: 24 / 4 + 1,
							shiftY: 24 / 4 + 1,
						},
					],
				},
			},

			weather: {
				title: 'Погода',
				icons: {
					custom: [
						{
							// color: BLUE,
							path: 'M13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973M8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4 4 0 0 1 8.5 1M7.053 11.276A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724z',
						},
					]
				}
			}
		}

		const tableExpandableGoupsConf = {
			state: {
				metrics: [
					{
						title: 'Обрив навантаження',
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.fBreakCurrent,
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: 'Обрив МСЕП',
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.fBreakPotential,
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.shortCircuitInvertor)),
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.shortCircuitInvertor,
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.hiTrasholdU220)),
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.hiTrasholdU220,
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.lowTrasholdU220)),
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.lowTrasholdU220,
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.overheat)),
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.overheat,
						
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.breakTemperatureSensor)),
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.breakTemperatureSensor,
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.breakCurrentSensor)),
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.breakCurrentSensor,
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.shortCircuitLoad)),
						unit: INFLUXDB.station_metrics.power_unit,
						metric: PowerUnit.metricKeys.shortCircuitLoad,
						format: (v) => PowerUnit.flagText(v),
					},
					{
						title: 'Обрив мережі живлення',
						unit: INFLUXDB.station_metrics.service_unit,
						metric: ServiceUnit.metricKeys.fExternalPwr,
						format: (v) => ServiceUnit.flagText(!v),
					},
					{
						title: 'Відкриття корпусу СКЗ',
						unit: INFLUXDB.station_metrics.service_unit,
						metric: ServiceUnit.metricKeys.fSecurityCircuitBoxDoor,
						format: (v) => ServiceUnit.boxDoorStatePromt(v),
					},
				]
			}
		}
		// Config chart
		// Define where set item throuth the defining
		// showInLines, showInTable, showInSegments, showInIcons
		// !Do not set `showInSegments` or other options if you do not want
		// to display the item in a specific region at all!
		// Define lines
		// free colors '#fc8452', '#9a60b4', '#ea7ccc'
		switch(this.station.uProtectSource) {
			case null:
				break
			case 'power': {
				this.chartItemsConfig.push(...[{
					title: 'Захисний потенціал',
					showInLines: true,
					showInTable: true,
					confidenceBand: true,
					yAxis: {
						id: 'line_left',
						side: 'left',
						formatter: (value) => `${value.toFixed(1)} В`,
					},
					lineType: 'solid',
					lineColor: '#5794f2',
					unit: INFLUXDB.station_metrics.power_unit,
					icon: 'power',
					metric: PowerUnit.metricKeys.eOut,
				}])
				break
			}
			case 'service': {
				this.chartItemsConfig.push(...[
					{
						title: 'Захисний потенціал',
						showInLines: true,
						showInTable: true,
						confidenceBand: true,
						yAxis: {
							id: 'line_left',
							side: 'left',
							formatter: (value) => `${value.toFixed(1)} В`,
						},
						lineType: 'solid',
						lineColor: '#5794f2',
						unit: INFLUXDB.station_metrics.service_unit,
						icon: 'service',
						metric: ServiceUnit.metricKeys.eAvg,
					},
					{
						title: 'Захисний потенціал мінімальний',
						showInLines: false,
						showInTable: false,
						confidenceBand: false,
						yAxis: {
							id: 'line_left',
							side: 'left',
							formatter: (value) => `${value.toFixed(1)} В`,
						},
						lineType: 'solid',
						lineColor: '#5794f2',
						unit: INFLUXDB.station_metrics.service_unit,
						icon: 'service',
						metric: ServiceUnit.metricKeys.eMin,
					},
					{
						title: 'Захисний потенціал максимальний',
						showInLines: false,
						showInTable: false,
						confidenceBand: false,
						yAxis: {
							id: 'line_left',
							side: 'left',
							formatter: (value) => `${value.toFixed(1)} В`,
						},
						lineType: 'solid',
						lineColor: '#5794f2',
						unit: INFLUXDB.station_metrics.service_unit,
						icon: 'service',
						metric: ServiceUnit.metricKeys.eMax,
					},
				])
				break
			}
		}

		this.chartItemsConfig.push(...[
			{
				title: 'Задане значення стабілізації потенціалу',
				// showInLines: false,
				showInTable: false,
				// confidenceBand: false,
				// yAxis: {
				// 	id: 'line_left',
				// 	side: 'left',
				// 	formatter: (value) => `${value.toFixed(1)} В`,
				// },
				// lineType: 'dashed',
				// lineColor: '#5794f2',
				unit: INFLUXDB.station_metrics.power_unit,
				icon: 'power',
				metric: PowerUnit.metricKeys.stationStabilizationPotential,
			},
			{
				title: 'Вихідна напруга',
				showInLines: true,
				showInTable: true,
				confidenceBand: true,
				yAxis: {
					id: 'line_left',
					side: 'left',
					formatter: (value) => `${value.toFixed(1)} В`,
				},
				lineType: 'solid',
				lineColor: '#ff994d',
				unit: INFLUXDB.station_metrics.power_unit,
				icon: 'power',
				metric: PowerUnit.metricKeys.uOut,
			},
			{
				title: 'Задане значення стабілізації напруги',
				// showInLines: false,
				showInTable: false,
				confidenceBand: false,
				// yAxis: {
				// 	id: 'line_left',
				// 	side: 'left',
				// 	formatter: (value) => `${value.toFixed(1)} В`,
				// },
				// lineType: 'dashed',
				// lineColor: '#ff994d',
				unit: INFLUXDB.station_metrics.power_unit,
				icon: 'power',
				metric: PowerUnit.metricKeys.stationStabilizationVoltage,
			},
			{
				title: 'Вихідний струм',
				showInLines: true,
				showInTable: true,
				confidenceBand: true,
				yAxis: {
					id: 'line_left',
					side: 'left',
					formatter: (value) => `${value.toFixed(1)} A`,
				},
				lineType: 'solid',
				lineColor: '#b877d9',
				unit: INFLUXDB.station_metrics.power_unit,
				icon: 'power',
				metric: PowerUnit.metricKeys.iOut,
			},
			{
				title: 'Задане значення стабілізації струму',
				// showInLines: false,
				showInTable: false,
				// confidenceBand: false,
				// yAxis: {
				// 	id: 'line_left',
				// 	side: 'left',
				// 	formatter: (value) => `${value.toFixed(1)} В`,
				// },
				// lineType: 'dashed',
				// lineColor: '#b877d9',
				unit: INFLUXDB.station_metrics.power_unit,
				icon: 'power',
				metric: PowerUnit.metricKeys.stationStabilizationCurent,
			},
			{
				title: 'Напруга в мережі 230В',
				showInLines: true,
				showInTable: true,
				confidenceBand: true,
				yAxis: {
					id: 'line_right',
					side: 'right',
					formatter: (value) => `${value.toFixed(0)} В`,
				},
				lineType: 'solid',
				lineColor: '#e02f44',
				unit: INFLUXDB.station_metrics.service_unit,
				icon: 'service',
				metric: ServiceUnit.metricKeys.u220,
			},
			{
				title: 'Температура в шафі',
				showInLines: true,
				showInTable: true,
				confidenceBand: true,
				yAxis: {
					id: 'line_left',
					side: 'left',
					formatter: (value) => `${value.toFixed(1)} °C`,
				},
				lineType: 'solid',
				lineColor: '#91cc75',
				unit: INFLUXDB.station_metrics.service_unit,
				icon: 'service',
				metric: ServiceUnit.metricKeys.tOutdoor,
			},
			{
				title: 'Вихідна потужність',
				showInLines: false,
				showInTable: false,
				confidenceBand: true,
				yAxis: {
					id: 'line_right',
					side: 'right',
					formatter: (value) => `${value.toFixed(0)} Вт`,
				},
				lineType: 'solid',
				lineColor: '#5470c6',
				unit: INFLUXDB.station_metrics.power_unit,
				icon: 'power',
				metric: 'outPower',
			},
			{
				title: 'Опір кола поляризації',
				showInLines: false,
				showInTable: false,
				confidenceBand: true,
				yAxis: {
					id: 'line_left',
					side: 'left',
					formatter: (value) => `${value.toFixed(1)} Ом`,
				},
				lineType: 'solid',
				lineColor: '#fac858',
				unit: INFLUXDB.station_metrics.power_unit,
				icon: 'power',
				metric: 'resistancePolarizationCircle',
			},
			{
				title: 'Напруга АКБ',
				showInLines: false,
				showInTable: false,
				confidenceBand: false,
				yAxis: {
					id: 'line_left',
					side: 'left',
					formatter: (value) => `${value.toFixed(1)} В`,
				},
				lineType: 'solid',
				lineColor: '#3ba272',
				unit: INFLUXDB.station_metrics.service_unit,
				icon: 'service',
				metric: ServiceUnit.metricKeys.uAkk,
			},
		])
		
		this.addElectricMeterLine()

		this.chartItemsConfig.push({
			title: 'Силовий модуль (стан)',
			showInTable: false,
			unit: INFLUXDB.station_metrics.power_unit,
			icon: 'power',
			metric: PowerUnit.metricKeys.stationState,
			format: (v) => PowerUnit.stateText(v),
		})
		this.chartItemsConfig.push({
			title: 'Режим стабілізації',
			showInTable: false,
			unit: INFLUXDB.station_metrics.power_unit,
			icon: 'power',
			metric: PowerUnit.metricKeys.stationStabilizationMode,
			format: (v) => PowerUnit.stabilizationModeText(v),
		})
		this.chartItemsConfig.push({
			title: 'Стан станції',
			showInTable: true,
			isExpand: false,
			group: tableExpandableGoupsConf.state,
		})

		// Define segments
		this.chartItemsConfig.push({
			title: 't° шафи |<->|',
			showInSegments: true,
			unit: INFLUXDB.station_metrics.service_unit,
			icon: 'service',
			metric: ServiceUnit.metricKeys.tOutdoor,
			isMetricInRange: (value) => {
				return Number(value) >= -40
					&& Number(value) <= 50
			},
		})
		this.chartItemsConfig.push({
			title: '230В    |<->|',
			showInSegments: true,
			unit: INFLUXDB.station_metrics.service_unit,
			icon: 'service',
			metric: ServiceUnit.metricKeys.u220,
			isMetricInRange: (value) => {
				const min = this.station.passport.get(Station.passportKeys.serviceUnit.self)[Station.passportKeys.serviceUnit.u220Min]
					?? this.station.getMetric(Station.passportKeys.serviceUnit.u220Min)?.value
				const max = this.station.passport.get(Station.passportKeys.serviceUnit.self)[Station.passportKeys.serviceUnit.u220Max]
					?? this.station.getMetric(Station.passportKeys.serviceUnit.u220Max)?.value
				return Number(value) >= min && Number(value) <= max
			},
		})
		this.chartItemsConfig.push({
			title: 'Зв\'язок модема',
			showInSegments: true,
			unit: INFLUXDB.station_metrics.modem_unit,
			icon: 'modem',
			metric: ModemUnit.metricKeys.isConnect,
			isMetricInRange: (value) => {
				return Boolean(value)
			},
		})
		this.chartItemsConfig.push({
			title: 'Зв\'язок сервісного модуля',
			showInSegments: true,
			unit: INFLUXDB.station_metrics.service_unit,
			icon: 'service',
			metric: ServiceUnit.metricKeys.isConnect,
			isMetricInRange: (value) => {
				return Boolean(value)
			},
		})
		this.chartItemsConfig.push({
			title: 'Зв\'язок силового модуля',
			showInSegments: true,
			unit: INFLUXDB.station_metrics.power_unit,
			icon: 'power',
			metric: PowerUnit.metricKeys.isConnect,
			isMetricInRange: (value) => {
				return Boolean(value)
			},
		})

		// Define flags
		this.chartItemsConfig.push(...[
			{
				title: 'Обрив навантаження',
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.fBreakCurrent,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: 'Обрив МСЕП',
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.fBreakPotential,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.shortCircuitInvertor)),
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.shortCircuitInvertor,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.hiTrasholdU220)),
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.hiTrasholdU220,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.lowTrasholdU220)),
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.lowTrasholdU220,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.overheat)),
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.overheat,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.breakTemperatureSensor)),
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.breakTemperatureSensor,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.breakCurrentSensor)),
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.breakCurrentSensor,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: capitalizeFirstLetter(PowerUnit.alertPromt(PowerUnit.metricKeys.shortCircuitLoad)),
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.shortCircuitLoad,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: 'Обрив мережі живлення',
				showInIcons: true,
				group: flagGroupsConf.breaks,
				unit: INFLUXDB.station_metrics.service_unit,
				metric: ServiceUnit.metricKeys.fExternalPwr,
				valueToIconCode: (v) => v ? 1 : 0,
			},
			{
				title: 'Відкриття корпусу СКЗ',
				showInIcons: true,
				group: flagGroupsConf.door_events,
				unit: INFLUXDB.station_metrics.service_unit,
				metric: ServiceUnit.metricKeys.fSecurityCircuitBoxDoor,
				valueToIconCode: (v) => {
					switch(v) {
						case ServiceUnit.boxDoorStateCodes.open:
							return 1
						case ServiceUnit.boxDoorStateCodes.close:
							return 0
						case ServiceUnit.boxDoorStateCodes.short:
							return null
					}
				},
			},
			{
				title: 'Режим стабілізації',
				showInIcons: true,
				group: flagGroupsConf.adjustments,
				unit: INFLUXDB.station_metrics.power_unit,
				metric: PowerUnit.metricKeys.stationStabilizationMode,
				valueToIconCode: () => 'custom',
			},
			{
				title: 'Блискавка',
				showInIcons: true,
				group: flagGroupsConf.weather,
				metric: 'lightning',
				valueToIconCode: () => 'custom',
			}
		])
	},
	
	async mounted() {
		this.$refs.fromDate.value = dateLocalString(this.$options.periods[0].start)
	},

	methods: {
		// Add to chart electric meter line if it is exist
		addElectricMeterLine() {
			// Define electric meter full energy source
			let electricMeterMetricUnit
			let electricMeterIcon
			let electricMeterMetric
			switch(this.station.passport?.get(Station.passportKeys.electricMeter.self)?.type) {
				// Meter type is impulse imput of service unit
				case ElectricMeter.versions.impulseInput:
					electricMeterMetricUnit = INFLUXDB.station_metrics.service_unit
					electricMeterIcon = 'service'
					electricMeterMetric = ServiceUnit.metricKeys.extPwrCounterEnergy
					break
				// Meter type is nik dlms or gama100
				case ElectricMeter.versions.nikDlms:
				case ElectricMeter.versions.gama100G1m:
				case ElectricMeter.versions.gama100G1b:
					electricMeterMetricUnit = INFLUXDB.station_metrics.electric_meter_unit
					electricMeterIcon = 'power_meter'
					electricMeterMetric = ElectricMeter.metricKeys.fullActiveEnergy
					break
			}
			
			// If electric meter define
			if (
				electricMeterMetric !== undefined
				&& electricMeterMetricUnit !== undefined
			) {
				this.chartItemsConfig.push({
					title: 'Спожито',
					showInLines: false,
					showInTable: false,
					confidenceBand: false,
					yAxis: {
						id: 'line_right',
						side: 'right',
						formatter: (value) => `${value.toFixed(0)}\nкВт⋅год`,
					},
					lineColor: '#73c0de',
					unit: electricMeterMetricUnit,
					icon: electricMeterIcon,
					metric: electricMeterMetric,
				})
			}
		},

		onPeriodChange(periodIndex) {
			// console.log('onDateChange')
			this.selectedPeriodIndex = periodIndex
			this.periodShift = 0
			this.pickedDate = this.$options.periods[this.selectedPeriodIndex].start
		},

		onDecrementPeriod() {
			if (this.periodSource == 'dropdown') {
				this.periodShift--
			} else if (this.periodSource == 'date_picker') {
				this.pickedDate = new Date(
					this.pickedDate.getTime() - this.$options.periods[this.selectedPeriodIndex].range
				)
			}
		},

		onIncrementPeriod() {
			if (!this.isIncrementPeriodPossible) {
				return
			}

			if (this.periodSource == 'dropdown') {
				this.periodShift++
			} else if (this.periodSource == 'date_picker') {
				this.pickedDate = new Date(
					this.pickedDate.getTime() + this.$options.periods[this.selectedPeriodIndex].range
				)
			}
		},

		onDateChange(event) {
			const newDate = event.target.value
			this.pickedDate = new Date(new Date(newDate).setHours(0, 0, 0, 0))
			this.periodSource = 'date_picker'
			this.periodShift = 0
			
		},
	},

	computed: {
		station() {
			return this.stationsStore.station(this.stationId)
		},

		metricsId() {
			return this.station.passport.get(Station.passportKeys.metricsId)
		},

		periodDropdownTitle() {
			if (this.periodSource == 'dropdown') {
				return this.periodShift == 0
					? this.$options.periods[this.selectedPeriodIndex].title
					: this.$options.periods[this.selectedPeriodIndex].rangeTitle
			} else if (this.periodSource == 'date_picker') {
				return this.$options.periods[this.selectedPeriodIndex].rangeTitle
			} else {
				return this.$options.periods[this.selectedPeriodIndex].rangeTitle
			}
		},

		isIncrementPeriodPossible() {
			if (this.periodSource == 'dropdown') {
				if (this.periodShift == 0) {
					return false
				}
			} else if (this.periodSource == 'date_picker') {
				if (this.chartsPeriodTo.getTime() >= new Date().getTime()) {
					return false
				}
			}

			return true
		},

		chartLineItems() {
			return this.chartItemsConfig.filter(
				(el) => Object.hasOwn(el, 'showInTable') || Object.hasOwn(el, 'showInLines')
			)
		},

		chartSegmentItems() {
			return this.chartItemsConfig.filter(
				(el) => Object.hasOwn(el, 'showInSegments')
			)
		},

		tableItems() {
			return this.chartItemsConfig.filter(
				(el) => Object.hasOwn(el, 'showInTable')
			)
		},

		chartsPeriodFrom() {
			if (this.periodSource == 'dropdown') {
				if (this.periodShift == 0) {
					return this.$options.periods[this.selectedPeriodIndex].start
				} else {
					return new Date(
						this.$options.periods[this.selectedPeriodIndex].start.getTime()
						+ this.$options.periods[this.selectedPeriodIndex].range * this.periodShift
					)
				}
			} else if (this.periodSource == 'date_picker') {
				return new Date(
					this.pickedDate.getTime()
					+ this.$options.periods[this.selectedPeriodIndex].range * this.periodShift
				)
			} else {
				return new Date(
					new Date().setHours(0, 0, 0, 0)
				)
			}
		},

		chartsPeriodTo() {
			if (this.periodSource == 'dropdown') {
				if (this.periodShift == 0) {
					return this.$options.periods[this.selectedPeriodIndex].end
				} else {
					return new Date(
						this.$options.periods[this.selectedPeriodIndex].end.getTime()
						+ this.$options.periods[this.selectedPeriodIndex].range * this.periodShift
					)
				}
			} else if (this.periodSource == 'date_picker') {
				return new Date(
					this.pickedDate.getTime()
					+ this.$options.periods[this.selectedPeriodIndex].range
					+ this.$options.periods[this.selectedPeriodIndex].range * this.periodShift
				)
			} else {
				return new Date(
					new Date().setHours(23, 59, 59, 999)
				)
			}
		},

		docHeight() {
			const	body = document.body,
					html = document.documentElement;
			const height = Math.max(
				body.scrollHeight,
				body.offsetHeight, 
				html.clientHeight,
				html.scrollHeight,
				html.offsetHeight
			) - Number(this.headerHeight.replace(/[^0-9]/gi, '')) - 110 //132
			return height
		},

		chartHeight() {
			if (this.isTable) {
				return String(this.docHeight / 3) + 'px'
			} else {
				return String(this.docHeight) + 'px'
			}
		},

		tableHeight() {
			if (this.isTable) {
				return String(this.docHeight / 3 * 2) + 'px'
			} else {
				return String(0) + 'px'
			}
		},
	},
}
</script>




<style scoped>
	/* Remove arrows from input Chrome, Safari, Edge, Opera */
	input.no-arrow::-webkit-outer-spin-button,
	input.no-arrow::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Remove arrows from input Firefox */
	input[type=number].no-arrow {
		appearance: textfield;
		-moz-appearance: textfield;
	}

	.scrollable-dropdown-button {
		width: 12rem;
	}
	.scrollable-dropdown {
		min-width: 26rem;
		max-height: calc(100vh - 220px);
		overflow-y: auto;
		overflow-x: hidden;
	}
	.form-check-label {
		/* font-size: small;
		font-weight: 500; */
		white-space: nowrap;
	}

	.form-check-label:hover {
		background: transparent;
	}

	.chart {
		display: inline-block;
		width: 100%;
		height: v-bind(chartHeight);
	}

	.bottom-table {
		display: inline-block;
		width: 100%;
		height: v-bind(tableHeight);
	}
</style>